import { GET_USER_STATE, SAVE_USER_STATE, SHOW_SPINNER, HIDE_SPINNER, SHOW_NOTIFICATION, ADD_RECENT_NOTE, SET_CURRENT_COURSE_ID, SET_CURRENT_SECTION_ID } from '../types';
import api from '../../api';
import defaultUserState from '../../config/defaultUserState.json';
import { recentNotesNo } from '../../config';
import sessionErrHandler from './sessionErrHandler';
import { newSession } from './auth';

export const getUserState = () => async dispatch => {
  dispatch({ type: SHOW_SPINNER, payload: 'Pobieram dane użytkownika'});
  let response;
  try {
    response = await api.get('/user/setting/user-state.json', { withCredentials: true });
    if (response.status === 200) {
      const userState = parseUserState(response.data.value)
      dispatch({ type: GET_USER_STATE, userState });
      dispatch(newSession());
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd podczas pobierania konfiguracji', type: 'error' }
      });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd podczas pobierania konfiguracji', dispatch);
  }
  dispatch({ type: HIDE_SPINNER });
}

export const saveUserSatate = (userState) => async (dispatch, getState) => {

  if (!userState.user) {
    const state = getState();
    const user = state.auth.user;
    if (user) userState.user = user;
  }
  
  const options = {
    method: 'post',
    data: { code: 'user-state.json', value: JSON.stringify(userState) },
    url: '/user/setting',
    withCredentials: true
  }

  let response;
  try {
    response = await api(options);
    if (response.status === 200) {
      dispatch({ type: SAVE_USER_STATE, userState });
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd zapisu na serwer' }
      });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd podczas zapisu konfiguracji', dispatch);
  }
}

export const resetState = () => dispatch => {
  dispatch(saveUserSatate(defaultUserState));
}

export const emptyState = () => dispatch => {
  dispatch(saveUserSatate({}));
}

export const delBookmark = (id) => (dispatch, getState) => {
  const { userState }  = getState()
  const { currentCourseId } = userState;
  const bookmarks = userState.bookmarks[currentCourseId].filter(bookmark => bookmark.id !== id);
  dispatch(saveUserSatate({ ...userState, bookmarks: { ...userState.bookmarks, [currentCourseId]: bookmarks } }));
}

export const addBookmark = (title, link) => (dispatch, getState) => {
  const { userState }  = getState();
  const { currentCourseId } = userState;
  const currentBookmarks = userState.bookmarks[currentCourseId];
  const alreadyExists = currentBookmarks && !!currentBookmarks.find(bookmark => bookmark.link === link);
  if (alreadyExists) {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { message: 'Zakładka do tego ćwiczenia już istnieje', type: 'info' }
    });
  } else {
    const bookmark = { id: getTimestamp(), title, link };
    let bookmarks;
    if (userState.bookmarks[currentCourseId]) {
      bookmarks = [ ...userState.bookmarks[currentCourseId], bookmark ];
    } else {
      bookmarks = [ bookmark ];
    }
    dispatch(saveUserSatate({ ...userState, bookmarks: { ...userState.bookmarks, [currentCourseId]: bookmarks } }));
  }
}

export const setDefaultExercise = (title, link, id) => (dispatch, getState) => {
  const { userState }  = getState();
  const { currentCourseId } = userState;
  const currentExercise = { title, link, id };
  dispatch(saveUserSatate({ ...userState, currentExercise: { ...userState.currentExercise, [currentCourseId]: currentExercise } }));
}

export const addRecentNote = (id) => (dispatch, getState) => {
  const { userState } = getState();
  const { recentNotes } = userState;
  const newRecentNotes = updateRecentNote(id, recentNotes);
  if (newRecentNotes) {
    dispatch(saveUserSatate({ ...userState, recentNotes: newRecentNotes }));
    dispatch({ type: ADD_RECENT_NOTE, id });
  }
}

export const delRecentNote = (id) => (dispatch, getState) => {
  const { userState } = getState();
  const { recentNotes } = userState;
  const newRecentNotes = deleteRecentNote(id, recentNotes);
  if (newRecentNotes) {
    dispatch(saveUserSatate({ ...userState, recentNotes: newRecentNotes }));
    dispatch({ type: ADD_RECENT_NOTE, id });
  }
}

export const setCurrentCourseId = (id) => (dispatch, getState) => {
  const { userState } = getState();
  if (id) {
    dispatch(saveUserSatate({ ...userState, currentCourseId: id }));
    dispatch({ type: SET_CURRENT_COURSE_ID, currentCourseId: id });
  }
}

export const setCurrentSectionId = (id) => (dispatch, getState) => {
  const { userState } = getState();
  if (id) {
    dispatch(saveUserSatate({ ...userState, currentSectionId: id }));
    dispatch({ type: SET_CURRENT_SECTION_ID, currentSectionId: id });
  }
}

export const clearCurrentSectionId = () => (dispatch, getState) => {
  const { userState } = getState();
  dispatch(saveUserSatate({ ...userState, currentSectionId: null }));
  dispatch({ type: SET_CURRENT_SECTION_ID, currentSectionId: null });
}

// export const markExerciseAsFinished = (exerciseId) => (dispatch, getState) => {
//   const { userState } = getState();
//   const { currentCourseId, currentSectionId, stats } = userState;
//   let finishedExercises = stats[currentCourseId].finished[currentSectionId].slice();
//   if (finishedExercises.indexOf(exerciseId) === -1) {
//     finishedExercises.push(exerciseId);
//     const newStats = { ...userState.stats };
//     newStats[currentCourseId].finished[currentSectionId] = finishedExercises;
//     dispatch(saveUserSatate({ ...userState, stats: newStats }));
//   }
// }

export const addExerciseAttempt = () => async (dispatch, getState) => {
  const { userState, courseSections } = getState();
  const { currentSectionId } = userState;
  const section = courseSections.find(course => course.id === currentSectionId)
  const isGame = section ? section.game : false;
  const options = {
    method: 'post',
    url: `/course/attempt/segment/${currentSectionId}`,
    withCredentials: true
  }
  if (isGame) options.url = `/course/attempt/gameSet/${currentSectionId}`;
  try {
    await api(options);
  } catch (e) {
    console.error(`Błąd api: ${options.url}`)
  }
}

export const markAsFinished = (exercise) => async (dispatch, getState) => {
  const type = exercise.elementType.toLowerCase();
  const options = {
    method: 'put',
    url: `/course/completed/${type}/${exercise.id}`,
    withCredentials: true
  }
  if (type === 'game') {
    const state = getState();
    const sectionId = state.userState.currentSectionId;
    options.url = `/course/completed/game/${exercise.type}/${sectionId}`;
  }
  try {
    await api(options);
  } catch (e) {
    console.error(`Błąd api: ${options.url}`)
  }
}
// internal functions --------------------------

function parseUserState(data) {
  let userState = {};
  try {
    userState = JSON.parse(data);
  } catch(e) {}
  return userState;
}

function getTimestamp() {
  return new Date().getTime();
}

function updateRecentNote(id, recentNotes) {
  const notes = [ ...recentNotes ];
  const idx = notes.indexOf(id);
  if (idx === 0) return false;
  if (idx !== -1) notes.splice(idx, 1);
  notes.unshift(id);
  return notes.slice(0, recentNotesNo); 
}

function deleteRecentNote(id, recentNotes) {
  const notes = [ ...recentNotes ];
  const idx = notes.indexOf(id);
  if (idx === -1) return false;
  notes.splice(idx, 1);
  return notes;
}
